export const AUTO_ORDER_PAY_CONFIG_KEY = "lst_auto_order_pay_config";

const INTERVAL_MIN = 1;
const INTERVAL_MAX = 300;
const AMOUNT_MIN = 0.01;
const AMOUNT_MAX = 9999999;

function clampInterval(v) {
    const n = Number.parseFloat(String(v ?? "").replace(/,/g, ""));
    if (!Number.isFinite(n))
        return 5;
    return Math.min(INTERVAL_MAX, Math.max(INTERVAL_MIN, n));
}

function clampAmount(v) {
    const n = Number.parseFloat(String(v ?? "").replace(/,/g, ""));
    if (!Number.isFinite(n))
        return 500;
    return Math.min(AMOUNT_MAX, Math.max(AMOUNT_MIN, n));
}

export function getDefaultAutoOrderPayConfig() {
    return {
        enabled: false,
        payPassword: "",
        scanIntervalSec: 5,
        maxAmount: 500
    };
}

export function getAutoOrderPayConfig() {
    try {
        const raw = localStorage.getItem(AUTO_ORDER_PAY_CONFIG_KEY);
        const o = raw ? JSON.parse(raw) : {};
        const d = getDefaultAutoOrderPayConfig();
        return {
            enabled: Boolean(o.enabled),
            payPassword: String(o.payPassword ?? d.payPassword),
            scanIntervalSec: clampInterval(o.scanIntervalSec ?? d.scanIntervalSec),
            maxAmount: clampAmount(o.maxAmount ?? d.maxAmount)
        };
    }
    catch {
        return getDefaultAutoOrderPayConfig();
    }
}

export function saveAutoOrderPayConfig(patch) {
    const cur = getAutoOrderPayConfig();
    const next = {
        enabled: patch.enabled != null ? Boolean(patch.enabled) : cur.enabled,
        payPassword: patch.payPassword != null ? String(patch.payPassword) : cur.payPassword,
        scanIntervalSec: patch.scanIntervalSec != null ? clampInterval(patch.scanIntervalSec) : cur.scanIntervalSec,
        maxAmount: patch.maxAmount != null ? clampAmount(patch.maxAmount) : cur.maxAmount
    };
    localStorage.setItem(AUTO_ORDER_PAY_CONFIG_KEY, JSON.stringify(next));
    try {
        window.dispatchEvent(new CustomEvent("auto-order-pay-config-change", { detail: next }));
    }
    catch {
    }
    return next;
}

export { INTERVAL_MIN, INTERVAL_MAX, AMOUNT_MIN, AMOUNT_MAX };
